(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yakca-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yakca-welcome-popup')) {
    customElements.define('yakca-welcome-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.storageKey = 'yakca-welcome-15-dismissed';
        this.onClose = () => {
          document.documentElement.style.overflow = this.previousOverflow;
          try { sessionStorage.setItem(this.storageKey, '1'); } catch (_) {}
        };
        this.dialog.addEventListener('close', this.onClose);
        this.querySelector('[data-welcome-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        });
        const feedback = this.querySelector('[data-newsletter-success], [data-newsletter-error]');
        const preview = new URLSearchParams(window.location.search).has('newsletter_preview');
        let dismissed = false;
        try { dismissed = sessionStorage.getItem(this.storageKey) === '1'; } catch (_) {}
        if (!feedback && !preview && (dismissed || this.hasAttribute('data-subscribed'))) return;
        this.timer = window.setTimeout(() => {
          if (!this.isConnected) return;
          this.previousOverflow = document.documentElement.style.overflow;
          this.dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
          if (feedback) feedback.focus();
        }, feedback || preview ? 0 : 1200);
      }
      disconnectedCallback() {
        window.clearTimeout(this.timer);
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
